(function (wpm, $, undefined) {

    // do something

}(window.wpm = window.wpm || {}, jQuery))